import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

/* Los servicios que devuelven una url de descarga pueden mandarla como cadena
   o dentro de un objeto, asi que buscamos la primera propiedad que sea una url */
const dameUrlDeDatos = (datos) => {

	if (!!!datos) {
		return false;
	}

	if (typeof datos == "string") {
		return datos;
	}

	let url = Object.values(datos).filter(d => typeof d == "string" && d.indexOf("http") == 0)[0];

	return (!!url) ? url : false;
};

const errors = {
	state: {
		totales: '',
		validaciones: [],
		validacionesNoTutordas: [],
		estadosValidacion: {},
		tutoradas: [],
		no_tutoradas: [],
		ofertasTitulacionCoordinacionPracticas: [],
		titulacionCoordinacionPracticas: [],
		asignaciones: [],
		documentos: [],
		loading: false
	},
	getters: {
		getTotales: state => state.totales,
		getTutoradas: state => state.tutoradas,
		getNoTutoradas: state => state.no_tutoradas,
		getOfertasTitulacionesCoordinacionPracticas: state => state.ofertasTitulacionCoordinacionPracticas,
		getTitulacionesCoordinacionPracticas: state => state.titulacionCoordinacionPracticas,
		//el filtro por año lo hacen ya los servicios damePracticas(No)TutoradasPorAnio
		getTutoradasAnioAcademico: state => state.tutoradas,
		getNoTutoradasAnioAcademico: state => state.no_tutoradas,
		getTutoradasPorEstados: state => {
			let tutoradas = new Object();
			if (state.tutoradas.length > 0) {
				tutoradas['en-evaluacion'] = state.tutoradas.filter(e => e.estadoCierre == 'pendientecierre');
				tutoradas['en-curso'] = state.tutoradas.filter(e => e.estadoCierre == 'encurso');
				tutoradas['evaluados'] = state.tutoradas.filter(e => e.estadoCierre == 'cerrada');

			}
			return tutoradas;
		},
		getNoTutoradasPorEstados: state => {
			let no_tutoradas = new Object();
			if (state.no_tutoradas.length > 0) {
				no_tutoradas['en-curso'] = state.no_tutoradas.filter(e => e.estadoCierre == 'encurso');
				no_tutoradas['en-evaluacion'] = state.no_tutoradas.filter(e => e.estadoCierre == 'pendientecierre');
				no_tutoradas['evaluados'] = state.no_tutoradas.filter(e => e.estadoCierre == 'cerrada');
			}
			return no_tutoradas;
		},
		getTutoradasHistorico: state => state.tutoradas,
		getTutoradasHistoricoPorEstados: state => {
			let tutoradas = new Object();
			if (state.tutoradas.length > 0) {
				tutoradas['en-evaluacion'] = state.tutoradas.filter(e => e.estadoCierre == 'pendientecierre');
				tutoradas['evaluados'] = state.tutoradas.filter(e => e.estadoCierre == 'cerrada');
			}
			return tutoradas;
		},
		getNoTutoradasHistorico: state => state.no_tutoradas,
		getNoTutoradasHistoricoPorEstados: state => {
			let no_tutoradas = new Object();
			if (state.no_tutoradas.length > 0) {
				no_tutoradas['en-evaluacion'] = state.no_tutoradas.filter(e => e.estadoCierre == 'pendientecierre');
				no_tutoradas['evaluados'] = state.no_tutoradas.filter(e => e.estadoCierre == 'cerrada');
			}
			return no_tutoradas;
		},

		getValidaciones: state => state.validaciones,
		getValidacionesPorEstados: state => {
			let validaciones = new Object();
			if (state.validaciones.length > 0) {
				validaciones['pendientes'] = state.validaciones.filter(e => e.idEstadoValidacion == 1);
				validaciones['validadas'] = state.validaciones.filter(e => e.idEstadoValidacion == 2);
				validaciones['rechazadas'] = state.validaciones.filter(e => e.idEstadoValidacion == 3);
				validaciones['no_tutorados'] = state.validacionesNoTutordas;
			}
			return validaciones;
		},
		getValidacionesNoTutoradas: state => state.validacionesNoTutordas.filter(e => e.idEstadoValidacion == 1),
		getAsignaciones: state => state.asignaciones,
		getAsignacionesAnioAcademico: state => state.asignaciones.filter(e => e.idAnioAcademico >= e.idAnioAcademicoActual),
		getAsignacionesPorEstados: state => {
			let asignaciones = new Object();
			if (state.asignaciones.length > 0) {
				asignaciones['pendientes'] = state.asignaciones.filter(e => e.idAnioAcademico >= e.idAnioAcademicoActual && e.idTutorAcademico == null);
				asignaciones['realizadas'] = state.asignaciones.filter(e => e.idAnioAcademico >= e.idAnioAcademicoActual && e.idTutorAcademico != null);
			}
			return asignaciones;
		},
		getAsignacionesHistorico: state => state.asignaciones.filter(e => e.idAnioAcademico < e.idAnioAcademicoActual),
		getAsignacionesHistoricoPorEstados: state => {
			let asignaciones = new Object();
			if (state.asignaciones.length > 0) {
				asignaciones['pendientes'] = state.asignaciones.filter(e => e.idAnioAcademico < e.idAnioAcademicoActual && e.idTutorAcademico == null);
				asignaciones['realizadas'] = state.asignaciones.filter(e => e.idAnioAcademico < e.idAnioAcademicoActual && e.idTutorAcademico != null);
			}
			return asignaciones;
		},

		getDocumentos: state => state.documentos,
		getLoading: (state) => {
			return state.loading;
		}

	},
	actions: {
		requestTotales: ({ commit, dispatch }) => {

			if (!!axios.defaults.headers.get.authorization) {

				return new Promise((resolve, reject) => {
					axios.get('/api/TutorAcademico/dameTotales').then(response => {
						if (response.data.status == 0) {
							commit('setTotales', response.data.datos);
							resolve(true);
						} else {
							commit('setError', response.data.status);
						}
					})
						.catch(function (error) {
							reject(false);
							dispatch('sendErrorServer', error.response);
						});
				});

			}
		},
		requestValidaciones: ({ commit, dispatch }) => {

			return new Promise((resolve, reject) => {
				axios.get('/api/TutorAcademico/damePracticasAvalidar').then(response => {
					if (response.data.status == 0) {
						if (!!response.data.datos) {
							commit('setValidaciones', response.data.datos);
						}
						resolve(true);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestValidacionesNoTutoradas: ({ commit, dispatch }) => {

			return new Promise((resolve, reject) => {
				axios.get('/api/TutorAcademico/damePracticasAvalidarNoTutoradas').then(response => {
					if (response.data.status == 0) {
						if (!!response.data.datos) {
							commit('setValidacionesNoTutoradas', response.data.datos);
						}
						resolve(true);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestEstadosValidacion: ({ commit, dispatch }) => {

			return new Promise((resolve, reject) => {
				axios.get('/api/Dominios/estadosValidacionPracticas').then(response => {
					if (response.data.status == 0) {
						commit('setEstadosValidacion', response.data.datos);
						resolve(true);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestTutoradas: ({ commit, dispatch, getters }, idAnioAcademico) => {

			const anio = (idAnioAcademico !== undefined && idAnioAcademico !== null) ? idAnioAcademico : getters.getAnioAcademico;

			return new Promise((resolve, reject) => {

				if (anio === null || anio === undefined) {
					resolve(false);
					return;
				}

				axios.get('/api/TutorAcademico/damePracticasTutoradasPorAnio/' + anio).then(response => {
					if (response.data.status == 0) {
						//si el año no tiene prácticas vaciamos el listado, si no se quedarían las del año anterior
						commit('setTutoradas', response.data.datos || []);
						resolve(true);
					} else {
						commit('setError', response.data.status);
						resolve(false);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestNoTutoradas: ({ commit, dispatch, getters }, idAnioAcademico) => {

			const anio = (idAnioAcademico !== undefined && idAnioAcademico !== null) ? idAnioAcademico : getters.getAnioAcademico;

			return new Promise((resolve, reject) => {

				if (anio === null || anio === undefined) {
					resolve(false);
					return;
				}

				axios.get('/api/TutorAcademico/damePracticasNoTutoradaPorAnio/' + anio).then(response => {
					if (response.data.status == 0) {
						//si el año no tiene prácticas vaciamos el listado, si no se quedarían las del año anterior
						commit('setNoTutoradas', response.data.datos || []);
						resolve(true);
					} else {
						commit('setError', response.data.status);
						resolve(false);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestUrlZipResultadosEncuestas: ({ commit, dispatch, getters }, payload) => {

			payload = payload || {};

			const anio = (payload.idAnioAcademico !== undefined && payload.idAnioAcademico !== null) ? payload.idAnioAcademico : getters.getAnioAcademico;

			//segun el listado desde el que se pide, tutoradas o no tutoradas
			const servicio = (!!payload.noTutoradas) ? 'dameUrlZipResultadosEncuestasNoTutoradasPorAnio' : 'dameUrlZipResultadosEncuestasTutoradasPorAnio';

			return new Promise((resolve, reject) => {

				if (anio === null || anio === undefined) {
					resolve(false);
					return;
				}

				axios.get(`/api/TutorAcademico/${servicio}/${anio}`).then(response => {
					if (response.data.status == 0) {
						resolve(dameUrlDeDatos(response.data.datos));
					} else {
						commit('setError', response.data.status);
						resolve(false);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestOfertasTitulacionCoordinacionPracticas: ({ state, commit, dispatch }) => {
			commit('loading')
			axios.get(`/api/TutorAcademico/dameOfertasDeTitulacionCoordinadorPractica`).then(response => {
				if (response.data.status == 0) {
					state.ofertasTitulacionCoordinacionPracticas = response.data.datos.lOfertasCoordinadorPractica
					state.titulacionCoordinacionPracticas = response.data.datos.lTitulacionesOfertasCoordinadorPractica
					console.log(state)
				}
				commit('endLoad')
			}).catch(function (error) {
				commit('setError', 500);
				dispatch('sendErrorServer', error.response);
			});
		},

		requestAsignaciones: ({ commit, dispatch }) => {
			commit('loading')
			return new Promise((resolve, reject) => {
				axios.get('/api/TutorAcademico/damePracticasAsignadas').then(response => {
					if (response.data.status == 0) {
						if (!!response.data.datos) {
							commit('setAsignaciones', response.data.datos);
						}
						resolve(true);
					} else {
						commit('setError', response.data.status);
					}
					commit('endLoad')
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestPractica: ({ commit, dispatch }, id) => {

			const token = window.localStorage.getItem("_token");
			axios.defaults.headers.get['authorization'] = `Bearer ${token}`;

			return new Promise((resolve, reject) => {

				axios.get('/api/TutorAcademico/dameDetallePractica/' + id).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestDocumentos: ({ commit, getters, dispatch }) => {
			axios.get(`/api/Dominios/tiposDocumentoAlumnoPracticas`).then(response => {
				(response.data.status == 0) ? commit('setDocumentos', response.data.datos) : '';
			})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
		},
		cambiaEstadoPractica: ({ commit, dispatch }, data) => {

			if (!!!data.fichero.ficheroB64) {
				data.fichero = null;
			}

			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/cambiaEstadoPractica', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 502);
						commit('changePracticaStatus', data);
						resolve(true);
						dispatch('requestTotales');
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		annadirObservacionManual: ({ commit, dispatch }, data) => {

			if (!!!data.fichero.ficheroB64) {
				data.fichero = null;
			}

			data.observacion = data.observacion.replaceAll("\n", '<br>');

			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/annadirObservacionManual', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 508);
						resolve(true);
						//dispatch('requestTotales');
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		marcarEvaluada({ commit, dispatch, getters }, id) {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/marcarComoEvaluada/' + id).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setError', 501);
						commit('changeEvaluacion', id);
						if (getters.getVeTutorados) dispatch('requestTutoradas')
						if (getters.getVeNoTutorados) dispatch('requestNoTutoradas')
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		marcarEvaluacionPendiente({ commit, dispatch, getters }, id) {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/marcarComoEvaluacionPendiente/' + id).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setError', 503);
						commit('changeEvaluacion', id);
						if (getters.getVeTutorados) dispatch('requestTutoradas')
						if (getters.getVeNoTutorados) dispatch('requestNoTutoradas')
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		dameContestacionEncuesta({ commit, dispatch }, id) {
			return new Promise((resolve, reject) => {
				axios.get('/api/TutorAcademico/dameContestacionEncuenstaPracticas/' + id).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		addDocumentoPractica({ commit }, data) {

			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/' + data.type, data.request).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					} else {
						reject(false);
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestPosiblesTutoresPractica: ({ commit, dispatch }, id) => {

			if (!!axios.defaults.headers.get.authorization) {

				return new Promise((resolve, reject) => {
					axios.get('/api/TutorAcademico/damePosiblesTutoresPractica/' + id).then(response => {
						if (response.data.status == 0) {
							resolve(response.data.datos);
						} else {
							commit('setError', response.data.status);
						}
					})
						.catch(function (error) {
							reject(false);
							dispatch('sendErrorServer', error.response);
						});
				});

			}
		},
		cambiarTutorAcademicoPractica: ({ commit, dispatch }, data) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/cambiarTutorAcademicoPractica', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 506);
						resolve(true);

					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		guardarNuevoTutorAcademicoPractica: ({ commit, dispatch }, data) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/guardarNuevoTutorAcademicoPractica', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 507);
						resolve(true);

					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		cambiarTutorEmpresaPractica: ({ commit, dispatch }, data) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/cambiarTutorEmpresaPractica', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 509);
						resolve(true);

					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		cambiarEspecialidadTitulacion: ({ commit, dispatch }, data) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/cambiarEspecialidadTitulacion', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 510);
						resolve(true);

					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		solicitarCuestionario({ commit, dispatch }, data) {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/solicitarCuestionario', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 507);
					} else {
						commit('setError', 512);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		dameMailsInteresTutor: ({ commit, dispatch }) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/dameMailsInteresTutor').then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);

					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		dameOfertasDeTitulacionCoordinadorPractica: ({ commit, dispatch }) => {
			return new Promise((resolve, reject) => {
				axios.post('/api/TutorAcademico/dameOfertasDeTitulacionCoordinadorPractica').then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);

					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestOfertaTutor: ({ commit, dispatch }, id) => {

			const token = window.localStorage.getItem("_token");
			axios.defaults.headers.get['authorization'] = `Bearer ${token}`;

			return new Promise((resolve, reject) => {

				axios.get('/api/TutorAcademico/dameDetalleOfertaPublicada/' + id).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});

		},
		cambiarCalificacionPractica: ({ commit, dispatch }, data) => {
			return new Promise((resolve, reject) => {
				axios.post('api/TutorAcademico/calificarPractica', data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						//dispatch('requestTotales');
					} else {
						commit('setError', response.data.status);
					}
				})
					.catch(function (error) {
						reject(false);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
	},
	mutations: {
		setTotales: function (state, totales) {
			state.totales = totales
		},
		setValidaciones: function (state, practicas) {
			state.validaciones = practicas
		},
		setValidacionesNoTutoradas: function (state, practicas) {
			state.validacionesNoTutordas = practicas
		},
		setEstadosValidacion: function (state, estados) {
			state.estadosValidacion = estados
		},
		setTutoradas: function (state, practicas) {
			state.tutoradas = practicas
		},
		setNoTutoradas: function (state, practicas) {
			state.no_tutoradas = practicas
		},
		setAsignaciones: function (state, practicas) {
			state.asignaciones = practicas
		},
		setDocumentos: function (state, data) {
			state.documentos = data;
		},
		changePracticaStatus: function (state, data) {
			state.validaciones.forEach(e => {
				if (e.idPractica == data.idPractica) {
					e.idEstadoValidacion = data.idEstado;
				}
			});
		},
		changeEvaluacion: function (state, id) {
			state.tutoradas.forEach(e => {
				if (e.idPractica == id) {
					e.evaluadaPorTutor = !e.evaluadaPorTutor;
				}
			});
		},
		loading(state) {
			state.loading = true;
		},
		endLoad(state) {
			state.loading = false;
		},

	}
}

export default errors;



// WEBPACK FOOTER //
// ./src/store/practicas.js